module.exports = __webpack_public_path__ + "img/14-about.347d7440.jpg";